import type { UserRole } from './dto';

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Quản trị viên',
  editor: 'Biên tập viên',
  guest: 'Khách',
};
export const ROLE_DESCRIPTIONS: Record<UserRole, string> = {
  admin: 'Quản lý công trình, tài khoản, nhật ký và toàn bộ dữ liệu mô hình.',
  editor: 'Quản lý công trình, liên kết mô hình, tải IFC và chỉnh vị trí trên bản đồ.',
  guest: 'Xem hồ sơ công trình, mô hình, tra cứu cấu kiện và đo.',
};
export const roleLabel = (role: UserRole): string => ROLE_LABELS[role];
